<template>
  <div class="point-festival-winners root">
    <div class="winners-title">รายชื่อผู้โชคดี</div>

    <div v-if="state == 'loading'" class="text-center text-muted">กำลังโหลด...</div>
    <div v-else-if="state == 'error'" class="text-center text-muted">
      ไม่พบข้อมูลกิจกรรม กรุณาลองใหม่ภายหลัง
    </div>
    <div v-else-if="!announced || rewards.length == 0" class="text-center text-muted">
      ประกาศรายชื่อผู้โชคดี {{ announceText }}
    </div>
    <div v-else>
      <div class="reward" v-for="item in rewards" :key="`reward-${item.id}`">
        <div class="reward-title">{{ item.title }}</div>
        <ol class="winner-list">
          <li v-for="(name, index) in item.winners" :key="`name-${index}`">
            <template v-if="name.taxCompanyName">
              {{ name.taxCompanyType }} {{ name.taxCompanyName }}
            </template>
            <template v-else>
              {{ name.taxPrefix || "คุณ" }} {{ name.taxFirstName }} {{ name.taxLastName }}
            </template>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchPointFestival,
  getAnnounceDate,
  isAnnounced,
  formatThaiShortDate,
} from "@/helper/pointFestival";

export default {
  name: "pointFestivalWinners",
  data() {
    return {
      state: "loading",
      luckyDraw: null,
    };
  },
  computed: {
    announced() {
      return isAnnounced(this.luckyDraw);
    },
    announceText() {
      return formatThaiShortDate(getAnnounceDate(this.luckyDraw));
    },
    rewards() {
      return ((this.luckyDraw && this.luckyDraw.rewards) || []).filter(
        (item) => item.winners && item.winners.length > 0
      );
    },
  },
  methods: {
    async init() {
      try {
        this.luckyDraw = await fetchPointFestival(this.$JWT);
        this.state = this.luckyDraw ? "ok" : "error";
      } catch (error) {
        console.log(error);
        this.state = "error";
      }
    },
  },
  beforeMount() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.init();
    window.loading(false);
  },
};
</script>

<style lang="scss" scoped>
.root {
  font-size: 16px;
  background: #fff;
  min-height: 100vh;
  padding: 24px 20px 40px;
}

.winners-title {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 20px;
}

.reward {
  margin-bottom: 20px;
  .reward-title {
    font-weight: 700;
    margin-bottom: 4px;
  }
  .winner-list {
    padding-left: 40px;
    margin: 0;
    line-height: 1.6;
  }
}
</style>
